export enum UserRole {
  Admin = 1,
  Manager,
  Supervisor,
  Agent,
  Client 
}
